import ForgotPasswordContent from "components/ForgotPassword/ForgotPasswordContent";
import RegisterLayout from "layouts/RegisterLayout/RegisterLayout";
import React from "react";

const ForgotPasswordPage = () => {
  return <RegisterLayout content={<ForgotPasswordContent />}></RegisterLayout>;
};

export default ForgotPasswordPage;
